import request from '@/utils/request'

export function getFabStatus(param) {
    let data = param
    return request({
        url: `/deliveryReport/epms9064/getFabStatus`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function getShipNoList1(param) {
    let data = param
    return request({
        url: `/deliveryReport/epms9000paint/getShipNoList1`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}

export function getBlockList(param) {
    let data = param
    return request({
        url: `/deliveryReport/epms9064/getBlockList`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}